<template>
    <div>
        <div class="d-flex " style="margin-bottom:10px;justify-content: space-between;">
            <div class="d-flex">
                <b-form-radio-group v-model="InvoiceRecordTab.applyStatus" @change="onApplyStatusChange">
                    <b-form-radio value="全部">全部</b-form-radio>
                    <b-form-radio value="已开票">已开票</b-form-radio>
                    <b-form-radio value="未开票">未开票</b-form-radio>
                </b-form-radio-group>
                <DatePicker type="daterange" v-model="InvoiceRecordTab.selectDates" transfer placement="bottom-end"
                    placeholder="选择支付时间" style="width: 200px" @on-change="onPayDateChange"></DatePicker>
                <b-input-group style="width:200px;margin-left:10px;">
                    <b-form-input size="sm" v-model="InvoiceRecordTab.keyword" placeholder="输入单号或发票编号"></b-form-input>
                    <b-input-group-append>
                        <b-button size="sm" v-on:click="onSearchInvoice()">查询</b-button>
                    </b-input-group-append>
                </b-input-group>
                <div style="color: red;padding-left:15px;">注意：只能对两个月内的定单申请开票</div>
            </div>
            <div>
                <b-button size="sm" v-on:click="showInvoiceAccount()">开票信息</b-button>
                <b-button size="sm" v-on:click="combineApplyInvoice()">合并开票</b-button>
            </div>

        </div>
        <div class="dataTable">
            <b-table id="fund-table" :fields="InvoiceRecordTab.fields" :items="InvoiceRecordTab.rows" small bordered
                hover show-empty empty-text="没有找到匹配的记录" :busy="InvoiceRecordTab.isTableBusy" caption-top>
                <div slot="table-busy" class="text-center text-info my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>加载中...</strong>
                </div>
                <template v-slot:cell(rowSelectCheckBox)="row">
                    <b-form-checkbox v-model="row.item.selected" :disabled="row.item.invoiceCode != null"
                        @change="deliveryItemSelectChange()">
                    </b-form-checkbox>
                </template>
                <template v-slot:cell(actionButton)="row">
                    <a v-if="row.item.invoiceStatus !== '申请成功' && row.item.invoiceStatus !== '已过期' && row.item.invoiceStatus !== '申请处理中'" href="#"
                        style="color:red;" v-on:click="applyInvoice(row)">申请开票</a>
                    <span v-if="row.item.invoiceStatus === '已过期'" href="#"
                        style="color:gray;" v-on:click="">不可开票</span>
                    <a v-if="row.item.invoiceStatus === '信息已填写'" href="#" style="color:blue;margin-left:10px;"
                        v-on:click="withdrawInvoice(row)">撤销</a>
                    <a v-if="row.item.invoiceLine2 === '纸质发票' || row.item.invoiceStatus === '申请成功' && row.item.invoiceLine2 === '电子发票'"
                        href="#" style="color:green;" v-on:click="showInvoice(row)">查看发票</a>
                </template>
            </b-table>
        </div>

        <div class="pageControl">
            <b-pagination v-model="InvoiceRecordTab.feSearch.limit.conditions.pageStart" style="margin-top:20px;"
                :total-rows="InvoiceRecordTab.feSearch.limit.conditions.total"
                :per-page="InvoiceRecordTab.feSearch.limit.conditions.pageLength" align="center" size="sm"
                ellipsis-text="..." first-text="首页" prev-text="上一页" next-text="下一页" last-text="尾页" limit="10"
                @change="onInvoiceRecordPageChange"></b-pagination>
        </div>

        <!-- 发票管理 -->
        <!-- 发票管理 -->
        <Modal v-model="invoiceModal.show" title="申请开具发票" :width="800">
            <Spin v-if="invoiceModal.loading" size="large" fix></Spin>
            <Row :gutter="16">
                <Col span="24">
                <Form ref="deliveryForm" label-position="right" :label-width="150">
                    <Row :gutter="16">
                        <Col span="24" class-name="invoiceField">
                        <FormItem label="开具类型:" required>
                            <Select v-model="invoiceModal.invoiceBuyerType" :disabled="true"
                                @on-change="onInvoiceBuyerTypeChange">
                                <Option value="个人">个人</Option>
                                <Option value="企业">企业</Option>
                                <!-- <Option value="事业单位">事业单位</Option> -->
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="24" class-name="invoiceField">
                        <FormItem label="发票类型:" required>
                            <RadioGroup v-model="invoiceModal.invoiceLine1" @on-change="onInvoiceLine1Change">
                                <Radio label="数电普票"></Radio>
                                <Radio v-if="invoiceModal.invoiceBuyerType === '企业'" label="数电专票"></Radio>
                            </RadioGroup>
                        </FormItem>
                        </Col>
                        <Col span="24" class-name="invoiceField">
                        <FormItem label="介质类型:" required>
                            <RadioGroup v-model="invoiceModal.invoiceLine2">
                                <Radio label="电子发票"></Radio>
                            </RadioGroup>
                        </FormItem>
                        </Col>
                        <Col span="24" class-name="invoiceField">
                        <FormItem label="发票抬头:" required>
                            <Input v-model="invoiceModal.invoiceBuyerName" :readonly="existInvoiceAccount"></Input>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col v-if="invoiceModal.invoiceBuyerType === '企业'" span="24" class-name="invoiceField">
                        <FormItem label="统一社会信用代码:" required>
                            <Input v-model="invoiceModal.invoiceBuyerTaxNum" :readonly="existInvoiceAccount"></Input>
                        </FormItem>
                        </Col>
                        <Col v-if="['增值税专用发票', '数电专票'].includes(invoiceModal.invoiceLine1)" span="24"
                            class-name="invoiceField">
                        <FormItem label="开户银行名称:">
                            <Input v-model="invoiceModal.invoiceBuyerBank" :readonly="existInvoiceAccount"></Input>
                        </FormItem>
                        </Col>
                        <Col v-if="['增值税专用发票', '数电专票'].includes(invoiceModal.invoiceLine1)" span="24"
                            class-name="invoiceField">
                        <FormItem label="基本开户账号:">
                            <Input v-model="invoiceModal.invoiceBuyerAccount" :readonly="existInvoiceAccount"></Input>
                        </FormItem>
                        </Col>
                        <Col v-if="['增值税专用发票', '数电专票'].includes(invoiceModal.invoiceLine1)" span="24"
                            class-name="invoiceField">
                        <FormItem label="注册场所地址:">
                            <Input v-model="invoiceModal.invoiceBuyerAddress" :readonly="existInvoiceAccount"></Input>
                        </FormItem>
                        </Col>
                        <Col v-if="['增值税专用发票', '数电专票'].includes(invoiceModal.invoiceLine1)" span="24"
                            class-name="invoiceField">
                        <FormItem label="注册固定电话:">
                            <Input v-model="invoiceModal.invoiceBuyerTel" :readonly="existInvoiceAccount"></Input>
                        </FormItem>
                        </Col>
                        <Col v-if="['增值税专用发票'].includes(invoiceModal.invoiceLine1)" span="24" class-name="invoiceField">
                        <FormItem label="邮寄地址:">
                            <Input v-model="invoiceModal.invoiceDeliveryAddress"></Input>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
                </Col>
            </Row>
            <div slot="footer" style="display:flex; justify-content:space-between;">
                <div>
                    <span>待开票金额: </span><span style="font-size:24px;font-weight:bold;">￥{{
                        numberToFixed(invoiceModal.invoiceValue, 2) }}</span>
                    <span>(货款:{{ numberToFixed(invoiceModal.invoiceProductValue, 2) }},
                        运费:{{ numberToFixed(invoiceModal.invoiceDeliveryFee, 2) }},
                        包装费:{{ numberToFixed(invoiceModal.invoicePackageFee, 2) }})</span>
                </div>
                <div>
                    <Button type="primary" @click="onApplyInvoice">保存</Button>
                    <Button v-if="invoiceModal.isCanSubmit" type="info" @click="preViewInvoice">预览</Button>
                </div>

            </div>
        </Modal>

        <InvoicePreviewModal ref="invoicePreviewModal" />
        <InvoiceAccountModal ref="invoiceAccountModal" />
    </div>
</template>

<script>
import api from '@/api/api';
import axios from 'axios';
import HttpRequest from '@/libs/axios';
import search from '@/libs/search';
import {
    formatDateTimeString,
    numberToFixed
} from "@/libs/utils";
import InvoicePreviewModal from './invoice-preview.vue';
import InvoiceAccountModal from './invoice-acount.vue';
import "@/style/global.css";
export default {
    name: "Invoice",
    components: {
        InvoicePreviewModal,
        InvoiceAccountModal
    },
    data() {
        return {
            invoiceModal: {
                show: false,
                loading: false,
                invoiceUuid: '',
                invoiceValue: 0,
                invoiceProductValue: 0,
                invoiceDeliveryFee: 0,
                invoicePackageFee: 0,
                invoiceUserUuid: '',
                invoiceBuyerType: '',
                invoiceBuyerName: '',
                invoiceLine1: '数电普票',
                invoiceLine2: '',
                invoiceBuyerTaxNum: '',
                invoiceBuyerBank: '',
                invoiceBuyerAccount: '',
                invoiceBuyerAddress: '',
                invoiceBuyerTel: '',
                invoiceDeliveryAddress: '',
                invoiceDeliveryUuidList: '',
                isCanSubmit: false
            },
            InvoiceRecordTab: {
                fields: [
                    { key: "rowSelectCheckBox", label: "选择" },
                    { key: 'orderCode', label: '发货单号', excel: true },
                    { key: 'deliveryCount', label: '商品数量', excel: true },
                    { key: 'deliveryValue', label: '开票金额', excel: true },
                    { key: 'deliveryFee', label: '配送费', excel: true },
                    { key: 'packageFee', label: '包装费', excel: true },
                    { key: 'payDate', label: '支付日期', excel: true },
                    { key: 'invoiceCode', label: '发票编号', excel: true },
                    { key: 'invoiceLine1', label: '发票类型', excel: true },
                    { key: 'invoiceLine2', label: '介质类型', excel: true },
                    { key: 'invoiceBuyerType', label: '开具类型', excel: true },
                    { key: 'invoiceStatus', label: '状态', excel: true },
                    { key: 'actionButton', label: '操作' }
                ],
                rows: [],
                isTableBusy: false,
                feSearch: search.getSearchParams(),
                keyword: '',
                selectDates: [],
                applyStatus: '全部'
            },
            existInvoiceAccount: true
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        formatDateTimeString,
        numberToFixed,
        init() {
            this.getMemberInvoiceRecord();
        },
        onPayDateChange(e) {
            this.InvoiceRecordTab.selectDates = e;
            let field = "deliveryDate";
            search.globalRemoveFilterConditionKey(this.InvoiceRecordTab.feSearch, field);
            this.InvoiceRecordTab.feSearch.filters.enable = true;
            this.InvoiceRecordTab.feSearch.filters.conditions.push({
                name: field,
                type: 'datebetween',
                value: JSON.stringify(e)
            });
            search.globalResetSearch(this.InvoiceRecordTab.feSearch);
            this.getMemberInvoiceRecord();
        },
        deliveryItemSelectChange() {
            // this.$nextTick(function () {
            //     let selectItems = this.InvoiceRecordTab.rows.filter(e => {
            //         return e.selected === true;
            //     });
            //     this.salesCart.orderForm.itemFee = 0;
            //     this.salesCart.orderForm.itemDiscountFee = 0;
            //     this.salesCart.orderForm.items = selectItems.map(
            //         e => {
            //             return { shoppingType: e.shoppingType, cartUuid: e.cartUuid };
            //         }
            //     );
            //     selectItems.forEach(e => {
            //         this.salesCart.orderForm.itemFee += e.totalMoney;
            //         this.salesCart.orderForm.itemDiscountFee += e.discountValue;
            //     });
            //     this.readContract = false;
            // });
        },
        onApplyStatusChange(type) {
            let field = "invoiceCode";
            search.globalRemoveFilterConditionKey(this.InvoiceRecordTab.feSearch, field);
            search.globalResetSearch(this.InvoiceRecordTab.feSearch);
            this.InvoiceRecordTab.feSearch.filters.enable = true;
            if (type == '未开票') {
                this.InvoiceRecordTab.feSearch.filters.conditions.push({
                    name: field,
                    type: 'eq',
                    value: '_DBNULL_'
                });
            }
            else if (type == '已开票') {
                this.InvoiceRecordTab.feSearch.filters.conditions.push({
                    name: field,
                    type: 'like',
                    value: 'FP'
                });
            }
            else {

            }
            this.getMemberInvoiceRecord();
        },
        onSearchInvoice() {
            let field = "concat(orderCode,invoiceCode)";
            search.globalRemoveFilterConditionKey(this.InvoiceRecordTab.feSearch, field);
            search.globalResetSearch(this.InvoiceRecordTab.feSearch);
            if (this.InvoiceRecordTab.keyword) {
                this.InvoiceRecordTab.feSearch.filters.enable = true;
                this.InvoiceRecordTab.feSearch.filters.conditions.push({
                    name: field,
                    type: 'like',
                    value: this.InvoiceRecordTab.keyword
                });
            }
            this.getMemberInvoiceRecord();
        },
        onInvoiceRecordPageChange(pageNum) {
            search.globalPageOnChange(this.InvoiceRecordTab.feSearch, pageNum);
            this.getMemberInvoiceRecord();
        },
        showInvoiceAccount() {
            this.$refs.invoiceAccountModal.showModal();
        },
        preViewInvoice() {
            this.invoiceModal.loading = true;
            console.log(this.invoiceModal);
            api.webGetInvoice({ deliveryUuidList: this.invoiceModal.invoiceDeliveryUuidList.split(','), invoiceUuid: this.invoiceModal.invoiceUuid }).then(res => {
                if (res.code === 0) {
                    this.invoiceModal.loading = false;
                    this.$refs.invoicePreviewModal.showModal(res.data);
                }
            });

        },
        refreshInvoice() {
            this.invoiceModal.show = false;
            this.getMemberInvoiceRecord();
        },
        getMemberInvoiceRecord() {
            if (this.checkMemberLogin()) {
                this.InvoiceRecordTab.isTableBusy = true;
                this.InvoiceRecordTab.feSearch.limit.conditions.pageLength = 20;
                api.webGetMyInvoiceRecord(this.InvoiceRecordTab.feSearch).then(res => {
                    this.InvoiceRecordTab.isTableBusy = false;
                    if (res.code === 0) {
                        this.InvoiceRecordTab.rows = res.data.records;
                        this.InvoiceRecordTab.rows.forEach(e => {
                            e.selected = false;
                        });
                        search.globalSetFilterRecordCount(this.InvoiceRecordTab.feSearch, res.data.filterRecordCount);
                    }
                });
            }
        },
        onInvoiceBuyerTypeChange(e) {
            if (e === '个人') {
                this.invoiceModal.invoiceLine1 = '数电普票';
                this.invoiceModal.invoiceLine2 = '电子发票';
            }
            this.invoiceModal.invoiceBuyerName = '';
            this.invoiceModal.invoiceBuyerTaxNum = '';
        },
        onInvoiceLine1Change(e) {
            if (e === '增值税普通发票') {
                this.invoiceModal.invoiceLine2 = '电子发票';
            }
            //else {//if (e === '增值税专用发票') {
            this.invoiceModal.loading = true;
            api.webGetInvoiceAccount().then(res => {
                this.invoiceModal.loading = false;
                if (res.code === 0) {
                    let invoiceAccountModel = res.data.invoiceAccountModel;
                    if (invoiceAccountModel) {
                        /*if (invoiceAccountModel == null || invoiceAccountModel.invoiceAccountStatus !== '已审批') {
                            this.invoiceModal.invoiceLine1 = '增值税普通发票';
                            this.$Modal.error({ title: '错误', content: '需要提供相应的开票信息供审批' });
                        }
                        else {*/
                        if (e === '增值税专用发票')
                            this.invoiceModal.invoiceLine2 = '纸质发票';
                        else
                            this.invoiceModal.invoiceLine2 = '电子发票';
                        this.invoiceModal.invoiceBuyerName = invoiceAccountModel.invoiceAccountBuyerName;
                        this.invoiceModal.invoiceBuyerTaxNum = invoiceAccountModel.invoiceAccountBuyerTaxNum;
                        this.invoiceModal.invoiceBuyerBank = invoiceAccountModel.invoiceAccountBuyerBank;
                        this.invoiceModal.invoiceBuyerAccount = invoiceAccountModel.invoiceAccountBuyerAccount;
                        this.invoiceModal.invoiceBuyerAddress = invoiceAccountModel.invoiceAccountBuyerAddress;
                        this.invoiceModal.invoiceBuyerTel = invoiceAccountModel.invoiceAccountBuyerTel;
                        this.invoiceModal.invoiceDeliveryAddress = invoiceAccountModel.invoiceAccountMailAddress;
                        //}
                        this.existInvoiceAccount = true
                    }
                    else {
                        this.existInvoiceAccount = false
                    }
                }
            });

            //}
        },
        combineApplyInvoice() {
            let selectItems = this.InvoiceRecordTab.rows.filter(e => {
                return e.selected === true;
            });
            if (selectItems.length === 0) {
                this.$bvModal.msgBoxOk("未选择需要开票的配送单", {
                    title: "提示",
                    buttonSize: "sm"
                });
                return;
            }
            console.log(selectItems);
            let totalValue = 0;
            let totalProductValue = 0;
            let totalDeliveryFee = 0;
            let totalPackageFee = 0;
            selectItems.forEach(e => {
                totalValue += e.deliveryValue;
                totalDeliveryFee += e.deliveryFee;
                totalPackageFee += e.packageFee;
            });
            if (totalValue > 100000) {
                this.$bvModal.msgBoxOk("选择的配送单开票金额合计不能大于10万", {
                    title: "提示",
                    buttonSize: "sm"
                });
                return;
            }
            totalProductValue = totalValue - totalDeliveryFee - totalPackageFee;
            let deliveryUuidList = selectItems.map(e => e.orderUuid);

            this.InvoiceRecordTab.isTableBusy = true;
            api.webGetInvoice({ deliveryUuidList: deliveryUuidList }).then(res => {
                this.InvoiceRecordTab.isTableBusy = false;
                if (res.code === 0) {
                    Object.assign(this.invoiceModal, res.data.invoiceModel);
                    this.invoiceModal.isCanSubmit = res.data.isCanSubmit;
                    if (res.data.isCanSubmit === false) {
                        this.invoiceModal.invoiceValue = totalValue;
                        this.invoiceModal.invoiceProductValue = totalProductValue;
                        this.invoiceModal.invoiceDeliveryFee = totalDeliveryFee;
                        this.invoiceModal.invoicePackageFee = totalPackageFee;
                        this.invoiceModal.invoiceUserUuid = selectItems[0].userUuid;
                        this.invoiceModal.invoiceBuyerType = '企业';
                        this.invoiceModal.invoiceLine1 = '数电普票';
                        this.invoiceModal.invoiceLine2 = '电子发票';
                        this.invoiceModal.invoiceDeliveryUuidList = deliveryUuidList.join(',');
                    }
                    this.invoiceModal.show = true;
                }
            });
        },
        applyInvoice(row) {
            this.InvoiceRecordTab.isTableBusy = true;
            api.webGetInvoice({ deliveryUuidList: [row.item.orderUuid], invoiceUuid: row.item.invoiceUuid }).then(res => {
                this.InvoiceRecordTab.isTableBusy = false;
                if (res.code === 0) {
                    Object.assign(this.invoiceModal, res.data.invoiceModel);
                    this.invoiceModal.isCanSubmit = res.data.isCanSubmit;
                    if (res.data.isCanSubmit === false) {
                        this.invoiceModal.invoiceValue = row.item.deliveryValue;
                        this.invoiceModal.invoiceProductValue = row.item.deliveryValue - row.item.deliveryFee - row.item.packageFee;
                        this.invoiceModal.invoiceDeliveryFee = row.item.deliveryFee;
                        this.invoiceModal.invoicePackageFee = row.item.packageFee;
                        this.invoiceModal.invoiceUserUuid = row.item.userUuid;
                        this.invoiceModal.invoiceBuyerType = '企业';
                        this.invoiceModal.invoiceLine1 = '数电普票';
                        this.invoiceModal.invoiceLine2 = '电子发票';
                        this.invoiceModal.invoiceDeliveryUuidList = row.item.orderUuid;
                        this.onInvoiceLine1Change(this.invoiceModal.invoiceLine1);
                    }
                    this.invoiceModal.show = true;
                }
            });
        },
        withdrawInvoice(row) {
            this.InvoiceRecordTab.isTableBusy = true;
            api.accounterWithdrawInvoice({ invoiceUuid: row.item.invoiceUuid }).then(res => {
                this.InvoiceRecordTab.isTableBusy = false;
                if (res.code === 0) {
                    this.getMemberInvoiceRecord();
                }
            });
        },
        onApplyInvoice() {
            this.invoiceModal.loading = true;
            api.webApplyInvoice(this.invoiceModal).then(res => {
                this.invoiceModal.loading = false;
                if (res.code === 0) {
                    this.invoiceModal.isCanSubmit = true;
                    this.getMemberInvoiceRecord();
                    this.invoiceModal.show = false;
                    this.$Modal.success({ title: "保存成功", content: "请预览发票，确认无误后提交。" });
                }
            });
        },
        showInvoice(row) {
            if (row.item.invoiceLine2 === '电子发票') {
                let data = {
                    serialNo: row.item.invoiceSerialNum
                };
                this.InvoiceRecordTab.isTableBusy = true;
                api.getInvoiceInfo(data).then(res => {
                    this.InvoiceRecordTab.isTableBusy = false;
                    if (res.code === 0) {
                        if (res.data.pdfurl) {
                            window.open(res.data.pdfurl, "_blank");
                        }
                    }
                });
            }
            else {
                this.InvoiceRecordTab.isTableBusy = true;
                api.webGetInvoice({ deliveryUuidList: [row.item.orderUuid] }).then(res => {
                    if (res.code === 0) {
                        this.InvoiceRecordTab.isTableBusy = false;
                        this.$refs.invoicePreviewModal.showModal(res.data);
                    }
                });
            }
        }
    }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/view/member/invoice.vue